import { render } from "./DropdownTitle.vue?vue&type=template&id=6dac584a"
const script = {}

const cssModules = {}
import style0 from "./DropdownTitle.vue?vue&type=style&index=0&id=6dac584a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__